import React from "react"
import dataLayerHelper from "../../helpers/datalayer.helper"

import {
  LastTestCard,
  ImageContainer,
  CTAText,
  CtaButton,
} from "./testimonial-slideCTA.styles"

const SlideCTA = ({ ctaImg, ctaText, btnLink }) => {
  return (
    <LastTestCard>
      <ImageContainer image={ctaImg} alt="testimonial slide" loading="lazy" />

      <div>
        <CTAText
          dangerouslySetInnerHTML={{
            __html: ctaText,
          }}
        />
        <CtaButton
          secondary
          url={btnLink}
          onClick={() =>
            dataLayerHelper({
              event: "testimonialSlideClick",
              action: "Button Click",
              label: "Last CTA Slide",
            })
          }
        >
          {" "}
          read more success stories
        </CtaButton>
      </div>
    </LastTestCard>
  )
}

export default SlideCTA
